import * as React from "react"
import { Grid } from "@mui/material"

import { DIPBrand, DIPSku } from "@components"
import { BACKEND_APIS, USER_ROLES } from "@constants"
import { useUserApp } from "@hooks"
import AdminNewListedFormIACardsOptions from "./IaCardsOptions"
import { adminNewListedErrorFormData, brandForm, skuForm, siteForm, adminNewListedFormRowData } from "../@signals"


export default function AdminNewListedFormDrawerContent() {
    const { userRole } = useUserApp()
    const myProps = {
            brand: { grid: { xs: 12 }, multiple: false, helperText: "Leave the field empty if you don\'t want to associate the product with any brand." },
            sku: { grid: { xs: 12 }, multiple: false, helperText: "Leave the field empty if you don\'t want to associate the product with any sku." }
    }

    return <Grid container spacing={2}>
        <Grid item {...myProps?.brand?.grid}>
            <DIPBrand
                error={adminNewListedErrorFormData.value?.brand}
                label="Brand"
                placeholder="Search Brand..."
                value={brandForm.value}
                onChange={e => {
                    brandForm.value = e.target.value
                }}
                {...myProps?.brand}
            />
        </Grid>

        <Grid item {...myProps?.sku?.grid}>
            <DIPSku
                urlAjax={userRole === USER_ROLES.RETAILER ? `${BACKEND_APIS.MASTER_DATA}/sku/retailer-find` : `${BACKEND_APIS.MASTER_DATA}/sku/find`}
                error={adminNewListedErrorFormData.value?.sku}
                filters={{
                    brand: brandForm.value, retailer: siteForm.value.siteID, country: siteForm.value.siteCountry
                }}
                label="SKU"
                placeholder="Search SKU..."
                value={skuForm.value}
                limitTags={4}
                onChange={e => skuForm.value = e.target.value}
                {...myProps?.sku}
            />
        </Grid>

        { !!adminNewListedFormRowData.value.IAOptionsDataList?.length && <Grid item xs={12} >
            <AdminNewListedFormIACardsOptions />
        </Grid> }
    </Grid>
}